import { observer } from "mobx-react-lite"

import { DisplayTokenTableValues } from "@/components/display-token-values"
import { dollarsPrettified } from "@/domains/library"
import { ILiquidityPool } from "@/domains/pools"

export const WalletColumn = observer(({ pool, isCompact }: { pool: ILiquidityPool; isCompact: boolean }) => {
  if (isCompact) {
    return <p className="text-t100">{dollarsPrettified(pool.walletValueUSD)}</p>
  }

  const tokenBalances = pool.tokens.map((token) => token.balance)
  return (
    <>
      <p className="text-t100">{dollarsPrettified(pool.walletValueUSD)}</p>
      <DisplayTokenTableValues tokens={pool.tokens} values={tokenBalances} />
    </>
  )
})
